import { AxiosError, AxiosResponse } from 'axios';

import { IMutationProps, MutateType, useMutation } from '@pricemoov-oss/moon';

import { LocaleKey } from 'helpers/i18n';

export interface Feature {
    feature: string;
    link: string;
    menu_group: string;
    menu_label: string;
    is_beta: boolean;
    menu_classname: string;
    page: {
        page_type: string;
        args: any;
    };
}

export interface User {
    id: number;
    firstname: string;
    lastname: string;
    email: string;
    title: string;
    company: string;
    language: LocaleKey;
    permissions: string[];
    roles: string[];
}

export interface AuthData {
    user: User;
    token: string;
    flags: string[];
    app_configuration: Feature[];
}

export interface UseLoginVariables {
    email: string;
    password: string;
}

export type UseLoginResponse = AxiosResponse<AuthData>;

function useLogin(mutationProps?: IMutationProps<UseLoginVariables, UseLoginResponse>) {
    return useMutation<
        // Params of the rest query
        UseLoginVariables,
        // The raw data retrieved from the backend
        UseLoginResponse,
        AxiosError
    >({
        source: 'rest',
        type: MutateType.Post,
        endPoint: '/login/',
        ...mutationProps,
    });
}

export default useLogin;
